import React from 'react';

const Industries = () => {
  const industries = [
    { name: 'Manufacturing', gradient: 'linear-gradient(135deg, #0066b2 0%, #004d8c 100%)', image: '/images/projects/manu.png' },
    { name: 'Healthcare', gradient: 'linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%)', image: '/images/projects/healthcare.png' },
    { name: ' Energy & Utility Monitoring Systems', gradient: 'linear-gradient(135deg, #5e35b1 0%, #4527a0 100%)', image: '/images/projects/power.png' },
    { name: 'Software Technology', gradient: 'linear-gradient(135deg, #00bcd4 0%, #0097a7 100%)', image: '/images/projects/technology.png' }
  ];

  return (
    <section id="work" className="section bg-white">
      <div className="container">
        <div className="row mb-5">
          <div className="col-lg-6">
            <h2 className="font-weight-600 mb-3">Enabling Industries<br/>To Be Future-Forward<br/><span style={{fontSize: '0.8em', fontWeight: 400}}>Through Innovation & Technology</span></h2>
          </div>
          <div className="col-lg-6">
            <p className="text-3">Being the best software dev company, we leverage our tech expertise to provide innovative product development services across various industries and help them achieve growth, improve productivity and overall efficiency.</p>
          </div>
        </div>
        <div className="row">
          {industries.map((industry, index) => (
            <div key={index} className="col-md-6 mb-4">
              <div className="industry-card" style={{background: industry.gradient, borderRadius: '15px', padding: '40px', position: 'relative', overflow: 'hidden', minHeight: '300px'}}>
                <div style={{position: 'relative', zIndex: 2}}>
                  <h3 className="text-white font-weight-600 mb-3" style={{whiteSpace: 'pre-line'}}>{industry.name}</h3>
                </div>
                <img src={industry.image} alt={industry.name} style={{position: 'absolute', right: 0, bottom: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.9}} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;
